import { createShell } from '../../shell/createShell';
import { HomeFunnel } from './HomeFunnel';
const routes = [];
export const homeShell = createShell(HomeFunnel, {
  options: {
    routes,
    namespace: 'home_sell'
  }
});